import { userApi } from './index';
import { CtvAccount, IUserAvailableServices } from '../../../models/Accounts';
import { config } from '../config';

export const ctvApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    getCtvInfo: build.query<CtvAccount, { accountId: string }>({
      query: ({ accountId }) => ({
        url: config.CTV.ACCOUNT_INFO(accountId),
      }),
      providesTags: () => ['Accounts'],
    }),
    getAvailableCtvServices: build.query<IUserAvailableServices, { accountId: string }>({
      query: ({ accountId }) => ({
        url: config.CTV.SERVICES_AVAILABLE(accountId),
      }),
      providesTags: () => ['Accounts'],
    }),
  }),
});
